import React from 'react';
interface SectionFadeProps {
  from: string;
  to: string;
  height?: string;
}

/**
 * Soft blended transition between two adjacent section backgrounds so the
 * long-scroll page never cuts abruptly from one color to the next.
 */
export function SectionFade({
  from,
  to,
  height = 'h-8 sm:h-12'
}: SectionFadeProps) {
  return <div aria-hidden="true" className={`w-full ${height}`} style={{
    background: `linear-gradient(180deg, ${from} 0%, ${to} 100%)`
  }} data-id="element-144" data-mp="1vmtr6v5tzzk4" />;
}